var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"100%","width":"100%","margin":"0","padding":"0"}},[_c('div',{staticClass:"ab",attrs:{"id":"cesiumContainer"}}),_c('div',[_vm._v(_vm._s(_vm.pmsg_div))])])}
var staticRenderFns = []

export { render, staticRenderFns }